var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonComponent',{staticClass:"text-center",attrs:{"id":"request_microsoft_login","variant":_vm.$props.variant,"text":_vm.buttonText[_vm.$props.type][_vm.$props.lang],"image":'https://cdn.systemico.net/abc/icons/microsoft.svg'},on:{"click":function($event){return _vm.loginWithGoogle()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }